const BASE_API = '/power-cable-portal'
export {BASE_API}